<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
         <div class="row">
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <div v-if="!status.detail" class="d-flex justify-content-center align-items-center m-5 p-5">
                            <b-spinner class="m-5" variant="info" role="status"></b-spinner>
                        </div>
                        <div v-else>
                            <form
                                v-if="readPermission == true"
                                @submit.prevent="productID ? requestUpdate() : requestCreate()"
                            >
                                <div class="row">
                                    <div class="col-lg-6">
                                        <b-form-group
                                            label-cols-sm="4"
                                            label-cols-lg="4"
                                            :label="$t('module.product')"
                                        >
                                            <multiselect
                                                v-model="createForm.productID"
                                                deselect-label="Can't remove this value"
                                                track-by="value" label="text"
                                                placeholder="Select one"
                                                :options="productDdl"
                                                :searchable="true"
                                                :allow-empty="false"
                                            />
                                            <div v-if="submitted && $v.createForm.productID.$error" class="text-danger font-size-12">
                                                <span v-if="!$v.createForm.productID.date">{{ $t("message.requiredX", [$t("module.product")]) }}</span>
                                            </div>
                                        </b-form-group>
                                    </div>
                                    <div class="col-lg-6">
                                        <b-form-group
                                            label-cols-sm="4"
                                            label-cols-lg="4"
                                            :label="$t('label.date')"
                                        >
                                            <date-picker
                                                v-model="createForm.date"
                                                type="date"
                                                format="YYYY-MM-DD"
                                                value-type="format"
                                                placeholder="Select date"
                                            />
                                            <div v-if="submitted && $v.createForm.date.$error" class="text-danger font-size-12">
                                                <span v-if="!$v.createForm.date.date">{{ $t("message.requiredX", [$t("label.date")]) }}</span>
                                            </div>
                                        </b-form-group>
                                    </div>
                                </div>
                                <div
                                    v-for="(item, index) of createForm.images"
                                    :key="index"
                                    class="row"
                                >
                                    <div class="col-11">
                                        <div class="card card-body shadow-lg border border-light">
                                            <div class="col-12">
                                                <div class="row">
                                                    <div class="col-lg-7">
                                                        <b-form-group
                                                            label-cols-sm="2"
                                                            label-cols-lg="2"
                                                            :label="$t('label.image')"
                                                        >
                                                            <div class="row">
                                                                <div
                                                                    v-for="(image, imageIndex) of item.images"
                                                                    :key="imageIndex"
                                                                    class="col-2 mx-4"
                                                                >
                                                                    <div
                                                                        v-if="image.id"
                                                                        class="image-container centered"
                                                                    >
                                                                        <div class="preview framed">
                                                                            <img
                                                                                :src="image.image"
                                                                                class="cursor-pointer"
                                                                                v-on:click="displayFile(image)"
                                                                            />
                                                                            <span
                                                                                class="remove-icon"
                                                                                v-on:click="deleteFileConfirmation(image)"
                                                                            >×</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <ImageUploader
                                                                :initialImages="[item.image]"
                                                                :showImageTop="false"
                                                                :buttonText="'+ ' + $t('label.images')"
                                                                :multiple="true"
                                                                @images-removed="removePhoto(index)"
                                                                @images-changed="updatePhoto($event, index)"
                                                            />
                                                            <div v-if="submitted && $v.createForm.images?.$each?.[index].images.$error" class="text-danger font-size-12">
                                                                <span v-if="!$v.createForm.images?.$each?.[index]?.images?.required">{{ $t("message.requiredX", [$t("label.image")]) }}</span>
                                                            </div>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-lg-5">
                                                        <div class="row">
                                                            <div class="col-12">
                                                                <b-form-group
                                                                    label-cols-sm="4"
                                                                    label-cols-lg="4"
                                                                    :label="$t('label.packagingMaterial')"
                                                                >
                                                                    <b-input
                                                                        v-model="createForm.images[index].packagingMaterial"
                                                                        :class="{ 'is-invalid': submitted && $v.createForm.images?.$each?.[index].packagingMaterial.$error }"
                                                                    />
                                                                    <div v-if="submitted && $v.createForm.images?.$each?.[index].packagingMaterial.$error" class="text-danger font-size-12">
                                                                        <span v-if="!$v.createForm.images?.$each?.[index]?.packagingMaterial?.required">{{ $t("message.requiredX", [$t("label.packagingMaterial")]) }}</span>
                                                                    </div>
                                                                </b-form-group>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-12">
                                                                <b-form-group
                                                                    label-cols-sm="4"
                                                                    label-cols-lg="4"
                                                                    :label="$t('label.xSize', [])"
                                                                >
                                                                    <b-input
                                                                        v-model="createForm.images[index].size"
                                                                        :class="{ 'is-invalid': submitted && $v.createForm.images?.$each?.[index].size.$error }"
                                                                    />
                                                                    <div v-if="submitted && $v.createForm.images?.$each?.[index].size.$error" class="text-danger font-size-12">
                                                                        <span v-if="!$v.createForm.images?.$each?.[index]?.size?.required">{{ $t("message.requiredX", [$t("label.xSize", [])]) }}</span>
                                                                    </div>
                                                                </b-form-group>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-12">
                                                                <b-form-group
                                                                    label-cols-sm="4"
                                                                    label-cols-lg="4"
                                                                    :label="$t('label.remark')"
                                                                >
                                                                    <b-textarea
                                                                        v-model="createForm.images[index].remark"
                                                                        :class="{ 'is-invalid': submitted && $v.createForm.images?.$each?.[index].remark.$error }"
                                                                    />
                                                                    <div v-if="submitted && $v.createForm.images?.$each?.[index].remark.$error" class="text-danger font-size-12">
                                                                        <span v-if="!$v.createForm.images?.$each?.[index]?.remark?.required">{{ $t("message.requiredX", [$t("label.remark")]) }}</span>
                                                                    </div>
                                                                </b-form-group>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-1">
                                        <div class="row">
                                            <b-button
                                                v-if="index!==0"
                                                variant="info"
                                                size="sm"
                                                @click="addImage(index, true)"
                                                class="mr-1"
                                            >
                                                <i :class="[
                                                    'mdi',
                                                    `mdi-plus`
                                                ]"></i>
                                            </b-button>
                                            <b-button
                                                :variant="index==0?'info':'danger'"
                                                size="sm"
                                                @click="productID && item.id && index!==0 ? deleteConfirmation(item) : addImage(index)"
                                            >
                                                <i :class="[
                                                    'mdi',
                                                    `mdi-${index==0?'plus':'minus'}`
                                                ]"></i>
                                            </b-button>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-4 text-center d-flex justify-content-end">
                                    <button
                                        v-if="updatePermission==true || createPermission==true"
                                        class="btn btn-primary w-md waves-effect waves-light"
                                        type="submit"
                                        :disabled="!status.save"
                                    >
                                        {{ $t(`${productID ? 'label.updateX' : 'label.createX'}`, [$t("module.productLabel")]) }}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
            id="image-delete"
            :title="image.isActive==0 ? $t('label.restoreX', [$t('label.image')]) : $t('label.deleteX', [$t('label.image')])"
            @hidden="reset"
            hide-header-close
        >
            <p class="my-4">{{ image.isActive==0 ? $t('message.restoreConfirmation') : $t('message.deleteConfirmation') }}</p>
            <template #modal-footer>
                <b-button variant="danger" @click="$bvModal.hide('image-delete')">
                    {{ $t('label.cancel') }}
                </b-button>
                <b-button
                    variant="info"
                    class="ml-2"
                    v-on:click="requestDelete"
                    :disabled="!statusImage.save"
                >
                    {{ image.isActive==0 ? $t('label.restoreX', []) : $t('label.deleteX', []) }}
                </b-button>
            </template>
        </b-modal>
        <b-modal
            id="file-delete"
            :title="file.isActive==0 ? $t('label.restoreX', [$t('label.image')]) : $t('label.deleteX', [$t('label.image')])"
            @hidden="reset"
            hide-header-close
        >
            <p class="my-4">{{ file.isActive==0 ? $t('message.restoreConfirmation') : $t('message.deleteConfirmation') }}</p>
            <template #modal-footer>
                <b-button variant="danger" @click="$bvModal.hide('file-delete')">
                    {{ $t('label.cancel') }}
                </b-button>
                <b-button
                    variant="info"
                    class="ml-2"
                    v-on:click="requestFileDelete"
                    :disabled="!statusImage.save"
                >
                    {{ file.isActive==0 ? $t('label.restoreX', []) : $t('label.deleteX', []) }}
                </b-button>
            </template>
        </b-modal>
        <b-modal
            id="file-display"
            :title="$t('label.image')"
            @hidden="reset"
            hide-header-close
            centered
            size="xl"
        >
            <img :src="file.imageUrl" style="width: 100%; height: 100%" />
            <template #modal-footer>
                <b-button variant="danger" @click="$bvModal.hide('file-display')">
                    {{ $t('label.cancel') }}
                </b-button>
            </template>
        </b-modal>
    </Layout>
</template>
<script>
import { sessionHelper } from "@/utils";
import { SESSION } from "@/constants";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import { productLabelNewMethods, productLabelImageMethods } from "@/state/helpers";
import { PRODUCT_LABEL_MODULE_NEW } from '@/state/modules/productLabelNew';
import { PRODUCT_LABEL_IMAGE_MODULE } from '@/state/modules/productLabelImage';
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
import { lookupMethods } from "@/state/helpers";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import ImageUploader from '@/components/upload-image';
import { required } from "vuelidate/lib/validators";

export default {
    page: {
        title: i18n.t("label.listingX", [i18n.t('module.productLabel')]),
    },
    components: { Layout, PageHeader, Multiselect, DatePicker, ImageUploader },
    async created() {
        await this.lookupProduct({ hasOptionAll: false });

        this.searchCriteria = sessionHelper.retrieveSearch(SESSION.PRODUCT_LABEL_SEARCH);
        this.productID = this.searchCriteria.selectedRecordId;
        await this.validPermissions();
        await this.getProductLabelData();
    },
    validations() {
        return {
            createForm: {
                productID: { required },
                date: { required },
                images: {
                    $each: {
                        images: { required },
                        packagingMaterial: { required },
                        size: { required },
                        remark: { required },
                    }
                },
            },
        };
    },
    data() {
        return {
            title: i18n.t("label.listingX", [i18n.t('module.productLabel')]),
            items: [
                {
                    text: i18n.t("module.dashboard"),
                    href: "/",
                },
                {
                    text: i18n.t("module.productLabel"),
                    href: "/product-label",
                },
                {
                    text: i18n.t("label.createX", [i18n.t('module.productLabel')]),
                    active: true,
                },
            ],
            permissions: sessionHelper.getPermissions(),
            updatePermission: null,
            createPermission: null,
            readPermission: null,
            submitted: false,
            createForm: this.defaultForm(),
            productID: "",
            image: {
                id: "",
                isActive: "",
            },
            file: {
                id: "",
                isActive: "",
                imageUrl: "",
            },
        };
    },
    methods: {
        ...productLabelImageMethods,
        ...productLabelNewMethods,
        ...lookupMethods,
        defaultForm() {
            return {
                productID: null,
                date: null,
                images: [
                    {
                        id: "",
                        remark: "",
                        packagingMaterial: "",
                        size: "",
                        images: [],
                        newImages: [],
                    },
                ],
            };
        },
        async validPermissions() {
            var jsonPermissions = JSON.parse(this.permissions)
            if (jsonPermissions.some(p => p.code === "RND_PLABEL_PLC")) {
                this.createPermission = true;
            }
            else {
                this.createPermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_PLABEL_PLR")) {
                this.readPermission = true;
            }
            else {
                this.readPermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_PLABEL_PLU")) {
                this.updatePermission = true;
            }
            else {
                this.updatePermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_PLABEL_PLUS")) {
                this.updateStatusPermission = true;
            }
            else {
                this.updateStatusPermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_PLABEL_PLD")) {
                this.downloadPermission = true;
            }
            else {
                this.downloadPermission = false;
            }
        },
        async getProductLabelData() {
            const createNewTabProduct = sessionHelper.retrieveSearch(SESSION.PRODUCT_LABEL_SEARCH);
            if (createNewTabProduct?.productID?.value) {
                this.createForm.productID = createNewTabProduct?.productID;
            }
            if (this.readPermission == true) {
                if (this.productID)
                {
                    await this.getProductLabelNew({ id: this.searchCriteria.selectedRecordId })
                        .then((item) => {
                            if (item?.success) {
                                this.createForm = {
                                    ...this.data,
                                    productID: {
                                        value: this.data.product.id,
                                        text: this.data.product.name
                                    },
                                    images: this.data.labels.map(label => ({
                                        ...label,
                                        images: label.images.map(image => ({
                                            ...image,
                                            image: image.imageUrl,
                                        })),
                                    })),
                                };
                            }
                        });
                }
            }
        },
        addImage(index, addOnly=false) {
            if (index == 0 || addOnly) {
                this.createForm.images.push({
                    id: "",
                    remark: "",
                    packagingMaterial: "",
                    size: "",
                    images: [],
                    newImages: [],
                });
            } else {
                this.createForm.images.splice(index, 1);
            }
        },
        displayFile(image) {
            this.file.imageUrl = image.imageUrl;
            this.$bvModal.show('file-display');
        },
        deleteConfirmation(image) {
            this.image = {
                id: image.id,
                isActive: image.isActive,
            };
            this.$bvModal.show('image-delete');
        },
        requestDelete() {
			let data = {
                id: this.image.id,
				isActive: this.image.isActive == 0 ? 1 : 0,
			};
			this.updateProductLabelImageStatus({data})
                .then((result) => this.$nextTick(() => {
                    if (result?.success) {
                        this.getProductLabelData();
                        this.$bvModal.hide('image-delete');
                    }
                }));
        },
        deleteFileConfirmation(file) {
            this.file = {
                id: file.id,
                isActive: file.isActive,
            };
            this.$bvModal.show('file-delete');
        },
        requestFileDelete() {
            let data = {
                id: this.file.id,
                isActive: this.file.isActive == 0 ? 1 : 0,
            };
            this.updateProductLabelStatusImageNew({data})
                .then((result) => this.$nextTick(() => {
                    if (result?.success) {
                        this.getProductLabelData();
                        this.$bvModal.hide('file-delete');
                    }
                }));
        },
        requestCreate() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                const data = {
                    productID: this.createForm.productID.value,
                    date: this.createForm.date,
                    images: this.createForm.images
                        .map(label => ({
                            remark: label.remark,
                            size: label.size,
                            packagingMaterial: label.packagingMaterial,
                            images: (label.images || []).filter(img => !img.id)
                        }))
                        .filter(label => label.images.length > 0),
                };
                this.createProductLabelNew({data, isCloseWhenSuccess: this.productID==null ? false : true })
                    .then((result) => this.$nextTick(() => {
                        if (result?.success && this.searchCriteria.previousPageName=='Product-label-listing') {
                            this.$router.push({ name: "Product-label-listing" });
                        }
                    }));
            }
        },
        requestUpdate() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                const data = {
                    id: this.productID,
                    productID: this.createForm.productID.value,
                    date: this.createForm.date,
                    images: this.createForm.images.map(item => ({
                        ...item,
                        images: item.images.filter(image => !image.id),
                    })).filter(item => item.id !== ""),
                    newImages: this.createForm.images.map(item => ({
                        ...item,
                        images: item.images || [],
                    })).filter(item => item.id == ""),
                };
                this.updateProductLabelNew({data, isCloseWhenSuccess: this.productID==null ? false : true})
                    .then((result) => this.$nextTick(() => {
                        if (result?.success && this.searchCriteria.previousPageName=='Product-label-listing') {
                            this.$router.push({ name: "Product-label-listing" });
                        }
                    }));
            }
        },
        updatePhoto(images, index) {
            const existingFiles = this.createForm.images[index].images.filter(img => img.id);

            const newFiles = images.map(img => img.file).filter(Boolean);

            this.createForm.images[index].images = [
                ...existingFiles,
                ...newFiles
            ];
        },
        removePhoto(index) {
            const current = this.createForm.images[index].images || [];
            
            this.createForm.images[index].images = current.filter(img => img && img.id);
        },
        reset() {
            this.image = {
                id: "",
                isActive: "",
            };
            this.file = {
                id: "",
                isActive: "",  
                imageUrl: "",
            };
        },
    },
    computed: {
        ...mapState(PRODUCT_LABEL_MODULE_NEW, ['status']),
        ...mapState(PRODUCT_LABEL_IMAGE_MODULE, { statusImage: 'status' }),
        productDdl() {
            return this.$store.state.lookup.productDdl;
        },
        data() {
            return this.$store.state.productLabelNew.details;
        },
    },
}
</script>

<style scoped>
.upload-container {
  text-align: left;
}

.image-container.centered {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.image-container-row {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.preview {
  position: relative;
  display: inline-block;
  text-align: center;
  margin-right: 10px;
}

.framed {
  padding: 20px;
  border: 2px solid #ddd;
  border-radius: 10px;
  background-color: white;
}

.preview img {
  max-width: 100px;
  max-height: 100px;
  display: block;
  border-radius: 50%;
}

.remove-icon {
  position: absolute;
  bottom: 5px;
  right: 5px;
  color: white;
  background-color: red;
  border-radius: 50%;
  cursor: pointer;
  padding: 2px 6px;
  font-size: 16px;
  line-height: 16px;
}

.upload-button {
  margin-bottom: 10px;
}
</style>